import validate from "/opt/suncore/build/20261104T102900Z-fec39489/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/suncore/build/20261104T102900Z-fec39489/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/middleware/auth.js")
}